module.exports = __webpack_public_path__ + "static/img/banner2-2.20bf2f3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/activity/activity202305/banner2-2.jpg
// module id = pJgr
// module chunks = 0